import * as React from "react";
import { JSONSchemaDefinition } from "@forgepoint/shared";

export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONObject
  | Array<JSONValue>
  | undefined;

export interface JSONObject {
  [key: string]: JSONValue;
}

/**
 * Narrows a JSONValue to a plain JSON object (not null, not an array).
 * @param value - The value to test
 * @returns True if the value is a JSONObject
 */
export function isJSONObject(value: JSONValue): value is JSONObject {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export interface JSONSchemaFieldTemplateProps<FormContextType> {
  id: string;
  label?: string;
  description?: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
  className?: string;
  schemaPath: string[];
  formContext?: FormContextType;
  defaultValue?: JSONValue;
  schemaFormat?: string;
  schema: JSONSchemaDefinition;
  currValue?: JSONValue;
}
